<template>
 <div data-app>
  <KTCard v-bind:title="title">
      <template v-slot:body>
        <div class="m-portlet__body">



            <div class="form-group m-form__group row">

              <div class="col-lg-2">
                <label class="col-lg-12 col-form-label">Üye:</label>
                  <div class="col-lg-12">
                    <b-form-select 
                      v-model="member_id" 
                      :options="members" 
                      value-field="id" 
                      text-field="name"
                    >
                    </b-form-select>
                  </div>
              </div>

              <div class="col-lg-6">
                <label class="col-lg-12 col-form-label">&nbsp;</label>
                  <div class="col-lg-12">
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="showResults(member_id)"
                    >
                    <i class="la la-filter"></i>
                        Filtrele
                    </b-button>
                    &nbsp;
                    <b-button
                      size="sm"
                      variant="warning"
                      @click="showOnlyCredits()"
                    >
                    <i class="la la-filter"></i>
                        Sadece Borçluları Listele
                    </b-button>
                    &nbsp;
                    <b-button
                      size="sm"
                      variant="success"
                      @click="resetFilters()"
                    >
                    <i class="la la-refresh"></i>
                        Temizle
                    </b-button>
                  </div>
              </div>

             

            </div>
          </div>
        
        <v-spacer></v-spacer>

      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th></th>
            <th>Üye No</th>
            <th>İsim Soyisim</th>
            <th>Telefon</th>
            <th>Bakiye</th>
            <th>Üyelik Tarihi</th>
            <th>Statü</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="stat in stats" :key="stat.id">
            <td><v-icon
                  class="la la-eye"
                  data-toggle="m-popover" title="Görüntüle"
                  @click="viewMember(stat.id)"
                  >
                </v-icon>
            </td>
            <td>{{ stat.member_no }}</td>
            <td>{{ stat.name }}</td>
            <td>{{ stat.mobile_phone }}</td>
            <td>{{ stat.balance }}</td>
            <td>{{ stat.membership_date | formatDate }}</td>
            <td>{{ stat.status }}</td>
            
          </tr>
          
        </tbody>
      </table>
    
    </template>
  </KTCard>    
</div>  
</template>
   
  <script>
  //import 'bootstrap/dist/css/bootstrap.min.css'; //for table good looks
  import KTCard from "@/view/content/Card.vue";
  import 'jquery/dist/jquery.min.js';
  //Datatable Modules
  import "datatables.net-dt/js/dataTables.dataTables"
  import "datatables.net-dt/css/jquery.dataTables.min.css"
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"

  import JSZip from 'jszip';
  window.JSZip = JSZip;
  
  import $ from 'jquery'; 
  import { GET_MEMBERS_REPORT } from "@/core/services/store/members.module";
  import { ALL_MEMBERS } from "@/core/services/store/members.module";
  import { GET_MEMBERS_WITH_CREDIT_BALANCE } from "@/core/services/store/members.module";
  

  export default {
    data: function() {
          return {
              members:[],
              member_id: '',
              title: "Eski Üye Listesi",
              stats: [],
              name: "",
              organizational_units: [],
              organizational_unit_id: "",
              registration_number: ""
          }
      },
    
    
    methods: {
      showResults(member_id) {
        $('#example').DataTable().destroy();
          this.$store.dispatch(GET_MEMBERS_REPORT, { member_id })
          .then((response) => {
              
              this.stats = response.data;
              setTimeout(function(){
                
              $('#example').DataTable(
                  {
                      pagingType: 'full_numbers',
                      pageLength: 25,
                      processing: true,
                      dom: 'Bfrtip',
                      filter: true,
                      retrieve: true,
                      searching: false,
                      paging: true,
                      responsive: true,
                      language: { "url": "assets/Turkish.json" },
                      order: [[0, 'asc']],
                      buttons: [
                      {
                          extend: 'copy',
                          text: 'Kopyala',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'excel', // Excel export button
                          text: 'Excel',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'print',
                          text: 'Yazdır',
                          footer: true,
                          className: 'btn btn-success'
                      },
                    ],
                  }
              );
            },
            1000
            );  
          })
      },

      showOnlyCredits() {
        $('#example').DataTable().destroy();
          this.$store.dispatch( GET_MEMBERS_WITH_CREDIT_BALANCE )
          .then((response) => {
              
              this.stats = response.data;
              setTimeout(function(){
                
              $('#example').DataTable(
                  {
                      pagingType: 'full_numbers',
                      pageLength: 25,
                      processing: true,
                      dom: 'Bfrtip',
                      filter: true,
                      retrieve: true,
                      searching: false,
                      paging: true,
                      responsive: true,
                      language: { "url": "assets/Turkish.json" },
                      order: [[0, 'asc']],
                      buttons: [
                      {
                          extend: 'copy',
                          text: 'Kopyala',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'excel', // Excel export button
                          text: 'Excel',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'print',
                          text: 'Yazdır',
                          footer: true,
                          className: 'btn btn-success'
                      },
                    ],
                  }
              );
            },
            1000
            );  
          })
      },

      viewMember(id) {
          this.$router.push({
              name: "members-form",
              params: { id: id, formType: "view" }
          });
      },

      resetFilters() {
        this.member_id = "";
        
        $('#example').DataTable().destroy();
        this.stats = [];
      }
    },
    
   
    components: {
       KTCard,
    },

    created() {
      this.$store.dispatch(ALL_MEMBERS)
        .then(( response ) => {
            this.members = response.data;
        })

     
    },


  }
  </script>
  